module.exports = __webpack_public_path__ + "static/media/music-square-add.516a6287.svg";